// ============================================================================
// Bedside / point-of-care tests — per-encounter record API.
//
// The catalogue autocomplete itself lives in `catalogues.js` (searchBedsideTests).
// This file is just the record CRUD: create / update / delete a row attached to
// an encounter. The server snapshots `result_unit` and `unit_price_pgk` at
// creation; the FE never has to know or send a price.
// ============================================================================

import { api } from './client.js'
import { endpoints } from './endpoints.js'

/**
 * POST a new bedside-test record onto an encounter.
 *
 * @param {number} encounterId
 * @param {{
 *   catalog: number,           // BedsideTest.id (FK)
 *   result_value?: string,     // free-text or numeric depending on test
 *   abnormal?: boolean,        // doctor flag — drives invoice + screening tally
 *   notes?: string,
 * }} body
 * @returns {Promise<object>} the created BedsideTestRecord (full read shape)
 */
export async function createBedsideTestRecord(encounterId, body) {
  const payload = { encounter: encounterId, ...body }
  const { data } = await api.post(endpoints.bedsideTestRecordCreate, payload)
  return data
}

/**
 * PATCH an existing record (inline edit of result / notes / abnormal flag).
 * Server keeps the snapshotted unit + price unchanged.
 */
export async function updateBedsideTestRecord(recordId, patch) {
  const { data } = await api.patch(endpoints.bedsideTestRecordDetail(recordId), patch)
  return data
}

/**
 * DELETE a record. Use sparingly — bedside-test rows are billable and a delete
 * removes the line item. Backend logs a `bedside_test.deleted` audit event.
 */
export async function deleteBedsideTestRecord(recordId) {
  await api.delete(endpoints.bedsideTestRecordDetail(recordId))
}
